export default __webpack_public_path__ + "static/media/XJTLU.924b4db2.jpeg";